import TimeHelper from "../../../services/TimeHelper";

export class BookingEvent {
  associated_employees
  available_online;
  duration;
  eligible_to_book;
  eligible_to_buy;
  event_level_id;
  event_level_name;
  event_namel;
  event_type_id;
  free_of_charge;
  has_prior_unfunded_events;
  session_credits_left;

  constructor(data) {
  	Object.assign(this, data);
  }

  shouldBuy () {
    return !this.eligible_to_book && this.eligible_to_buy;
  }
}

export class EventAvailability {
  club_number;
  employee_id;
  end_date_time;
  start_date_time;

  constructor(data) {
    Object.assign(this, data);
    this.start_date_time = new Date(this.start_date_time.substring(0, 19));
    this.end_date_time = new Date(this.end_date_time.substring(0, 19));
  }

  getStartTime() {
    return this.start_date_time.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true});
  }

  getSlotStart() {
    return TimeHelper.toApiDate(this.start_date_time);
  }


}

export class Booking { // should share Slot interface with Availability
  constructor(data) {
    Object.assign(this, data);
    this.start_date_time = this.booked_at = new Date(this.booked_at.substring(0, 19));
  }

  getStartTime() {
    return this.start_date_time.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true});
  }

  getSlotStart() {
    return TimeHelper.toApiDate(this.start_date_time);
  }
}